"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WappContext = void 0;
exports.withWapp = withWapp;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _callSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/callSuper"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["forwardedRef"],
  _excluded2 = ["wappRef"];
var WappContext = exports.WappContext = /*#__PURE__*/_react["default"].createContext({
  wapp: null,
  req: null,
  res: null
});
function withWapp(ComposedComponent) {
  var WithWapp = /*#__PURE__*/function (_PureComponent) {
    function WithWapp(props, context) {
      var _this;
      (0, _classCallCheck2["default"])(this, WithWapp);
      _this = (0, _callSuper2["default"])(this, WithWapp, [props, context]);
      var res = context.res;
      _this.unsubscribe = null;
      _this.handlers = {};
      _this.setHandler = _this.setHandler.bind(_this);
      _this.getHandlers = _this.getHandlers.bind(_this);
      _this.onLocationChange = _this.onLocationChange.bind(_this);
      _this.state = {
        url: res.wappResponse.store.getState("req.url")
      };
      return _this;
    }
    (0, _inherits2["default"])(WithWapp, _PureComponent);
    return (0, _createClass2["default"])(WithWapp, [{
      key: "getHandlers",
      value: function getHandlers() {
        return this.handlers;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var res = this.context.res;
        var getHandlers = this.getHandlers;
        this.unsubscribe = res.wappResponse.store.subscribe(function (_ref) {
          var type = _ref.type,
            payload = _ref.payload;
          var handlers = getHandlers();
          if (type === "INS_RES" && payload.name === "responses") {
            if (handlers["requestResolved"]) {
              handlers["requestResolved"](payload);
            }
          }
          if (type === "SET_REQ" && payload.name === "user") {
            if (handlers["userChange"]) {
              var _payload$value;
              handlers["userChange"]((_payload$value = payload.value) !== null && _payload$value !== void 0 && _payload$value._id ? (0, _objectSpread2["default"])({}, payload.value) : null);
            }
          }
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
      }
    }, {
      key: "onLocationChange",
      value: function () {
        var _onLocationChange = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(url) {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!this.handlers["locationChange"]) {
                  _context.next = 3;
                  break;
                }
                _context.next = 3;
                return this.handlers["locationChange"](url);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function onLocationChange(_x) {
          return _onLocationChange.apply(this, arguments);
        }
        return onLocationChange;
      }()
    }, {
      key: "setHandler",
      value: function setHandler(type, handler) {
        this.handlers[type] = handler;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          forwardedRef = _this$props.forwardedRef,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
        var setHandler = this.setHandler;
        props.subscribe = {
          locationChange: function locationChange(fn) {
            setHandler("locationChange", fn);
            return function () {
              setHandler("locationChange", null);
            };
          },
          requestResolved: function requestResolved(fn) {
            setHandler("requestResolved", fn);
            return function () {
              setHandler("requestResolved", null);
            };
          },
          userChange: function userChange(fn) {
            setHandler("userChange", fn);
            return function () {
              setHandler("userChange", null);
            };
          }
        };
        return /*#__PURE__*/_react["default"].createElement(ComposedComponent, Object.assign({}, props, {
          ref: forwardedRef
        }));
      }
    }]);
  }(_react.PureComponent);
  var displayName = ComposedComponent.displayName || ComposedComponent.name || "Component";
  WithWapp.displayName = "WithWapp(".concat(displayName, ")");
  WithWapp.contextType = WappContext;
  WithWapp.ComposedComponent = ComposedComponent;
  return /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    var wappRef = props.wappRef,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(WithWapp, Object.assign({}, rest, {
      ref: wappRef,
      forwardedRef: ref
    }));
  });
}